/**
 * Parse a CBT tenant slug from a hostname.
 *
 * Prod: `{cbt_subdomain}.aimsis.com` with baseDomain `aimsis.com` → `cbt_subdomain`.
 * Rejects bare base domain and invalid slug shapes.
 */
const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;
export function parseTenantSlugFromHost(host, baseDomain) {
    const normalizedHost = host.split(':')[0]?.toLowerCase().trim() ?? '';
    const normalizedBase = baseDomain.toLowerCase().trim();
    if (!normalizedHost || !normalizedBase)
        return null;
    if (normalizedHost === normalizedBase)
        return null;
    const suffix = `.${normalizedBase}`;
    if (!normalizedHost.endsWith(suffix))
        return null;
    const slug = normalizedHost.slice(0, -suffix.length);
    if (!slug || slug.includes('.'))
        return null;
    if (!SLUG_PATTERN.test(slug))
        return null;
    return slug;
}
//# sourceMappingURL=tenant-host.js.map